import React, { Fragment } from 'react'
import MEModal from '../../components/MEModal'
import { Button, MenuItem } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fixLmsId, uploadGradesToLms } from '../actions'
import ButterToast, { Cinnamon } from 'butter-toast'

class CanvasActions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fixLmsIdModalOpen: false,
      uploadGradesModalOpen: false,
    }
    this.toggleFixLmsModal = this.toggleFixLmsModal.bind(this)
    this.submitFixLmsId = this.submitFixLmsId.bind(this)
    this.toggleUploadGradesModal = this.toggleUploadGradesModal.bind(this)
    this.submitUploadGrades = this.submitUploadGrades.bind(this)
  }

  toggleFixLmsModal() {
    this.setState({
      fixLmsIdModalOpen: !this.state.fixLmsIdModalOpen,
    })
  }

  async submitFixLmsId() {
    let data = { user_id: this.props.user_id }
    let resp = await this.props.fixId(data)
    this.toggleFixLmsModal()

    if (resp.status === 200) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Canvas ID Fixed"
            content={`Successfully fixed Canvas ID.`}
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } else {
      let error = resp.error
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={`There was an error trying to fix Canvas ID. ${error}`}
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
      })
    }
  }

  toggleUploadGradesModal() {
    this.setState({
      uploadGradesModalOpen: !this.state.uploadGradesModalOpen,
    })
  }

  async submitUploadGrades() {
    let data = { user_id: this.props.user_id }
    let resp = await this.props.uploadGrades(data)
    this.toggleUploadGradesModal()

    if (resp.status === 204) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Grades Being Uploaded"
            content={`Grades are being uploaded to Canvas, an offline task has been created.`}
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } else {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={`There was an error trying to upload grades to Canvas.`}
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
      })
    }
  }

  render() {
    return (
      <Fragment>
        <MenuItem header>CANVAS</MenuItem>
        <MenuItem onClick={this.toggleFixLmsModal} className="me-list-item">
          <i className="fal fa-link fa-fw mr-2 color_teal" /> Fix Student Id
        </MenuItem>
        <MenuItem
          onClick={this.toggleUploadGradesModal}
          className="me-list-item"
        >
          <i className="fal fa-upload fa-fw mr-2 color_teal" /> Upload Grades
        </MenuItem>
        <MEModal
          show={this.state.fixLmsIdModalOpen}
          close={this.toggleFixLmsModal}
          title="Confirm"
        >
          <form onSubmit={e => e.preventDefault()}>
            <p>
              Attempt to resolve the Canvas Id for{' '}
              <i>{this.props.user_full_name}</i>?
            </p>
            <Button
              className="mt-3 btn-myed btn-primary-myed"
              type="button"
              bsStyle="primary"
              onClick={this.submitFixLmsId}
            >
              Submit
            </Button>
          </form>
        </MEModal>
        <MEModal
          show={this.state.uploadGradesModalOpen}
          close={this.toggleUploadGradesModal}
          title="Confirm"
        >
          <form onSubmit={e => e.preventDefault()}>
            <p>
              Upload Activity grades to Canvas for{' '}
              <i>{this.props.user_full_name}</i>?
            </p>
            <Button
              className="mt-3 btn-myed btn-primary-myed"
              type="button"
              bsStyle="primary"
              onClick={this.submitUploadGrades}
            >
              Submit
            </Button>
          </form>
        </MEModal>
      </Fragment>
    )
  }
}

CanvasActions.propTypes = {
  user_id: PropTypes.string,
  user_full_name: PropTypes.string,
  fixId: PropTypes.func,
  uploadGrades: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    peopleData: state.peopleRowData,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fixId: userId => dispatch(fixLmsId(userId)),
    uploadGrades: userId => dispatch(uploadGradesToLms(userId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CanvasActions)
